import { render, staticRenderFns } from "./PaidVisaDetail.vue?vue&type=template&id=36d85d12&"
import script from "./PaidVisaDetail.vue?vue&type=script&lang=js&"
export * from "./PaidVisaDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaidVisaDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports